var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7175 56.2399H47.0509L57.0509 84.9066L33.7175 56.2399ZM87.0509 56.2399H73.7175L63.7175 84.9066L87.0509 56.2399ZM60.3842 86.2399L50.3842 56.2399H70.3842L60.3842 86.2399ZM47.0509 52.9066H33.7175L40.3842 42.9066L47.0509 52.9066ZM87.0509 52.9066H73.7175L80.3842 42.9066L87.0509 52.9066ZM67.0509 52.9066H53.7175L60.3842 42.9066L67.0509 52.9066ZM44.8509 42.9066H57.0509L50.3842 52.9066L44.8509 42.9066ZM63.7175 42.9066H77.0509L70.3842 52.9066L63.7175 42.9066Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 29.3233L91.3008 91.8233M60.0508 105.573C54.1413 105.573 48.2897 104.409 42.83 102.148C37.3704 99.8864 32.4096 96.5717 28.231 92.3931C24.0523 88.2145 20.7377 83.2537 18.4762 77.7941C16.2147 72.3344 15.0508 66.4828 15.0508 60.5733C15.0508 54.6638 16.2147 48.8122 18.4762 43.3525C20.7377 37.8929 24.0523 32.9321 28.231 28.7535C32.4096 24.5749 37.3704 21.2602 42.83 18.9987C48.2897 16.7373 54.1413 15.5733 60.0508 15.5733C71.9855 15.5733 83.4314 20.3144 91.8706 28.7535C100.31 37.1926 105.051 48.6386 105.051 60.5733C105.051 72.508 100.31 83.954 91.8706 92.3931C83.4314 100.832 71.9855 105.573 60.0508 105.573Z",
    stroke: "#FE113C",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden5);
export default __webpack_public_path__ + "static/media/forbidden5.175aa17916a0332622ead7968f159c69.svg";
export { ForwardRef as ReactComponent };